import request from '@/utils/request'

export function updateActIconSortCfg(data) {
  return request({
    url: 'api/v1/act-icon/updateCfg',
    method: 'post',
    data: data
  })
}

export function getActIconSortCfgList(data) {
  return request({
    url: 'api/v1/act-icon/getList',
    method: 'post',
    data: data
  })
}

export function delActIconSortCfgList(data) {
  return request({
    url: 'api/v1/act-icon/deleteCfg',
    method: 'delete',
    data: data
  })
}

export function getIconTypes() {
  return request({
    url: 'api/v1/act-icon/getIconTypes',
    method: 'post'
  })
}

export function IconAsyncOss(data) {
  return request({
    url: 'api/v1/act-icon/asyncOss',
    method: 'post',
    data: data
  })
}
